<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";
import preventiveMeasureAPI from "@/services/standards/preventiveMeasure/preventiveMeasureAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import Swal from "sweetalert2";

function blankRow() {
  return {
    peligro: null, medida: "", jerarquia: null,
    fecha_limite: null, avance: 0, evidencia_file: null, observaciones: "",
    _uploading: false,
  };
}

export default {
  page: { title: "Matriz de Medidas de Prevención y Control" },
  components: { Layout, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      title: "4.2.1 Matriz de Medidas de Prevención y Control",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        { text: "4.2.1 Medidas de prevención y control", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      matrixId: this.$route.params.matrix || null,
      catalog: { peligros: [], jerarquia: [] },
      form: { version: "1.0", fecha: new Date().toISOString().substring(0, 10), observacion: null },
      rows: [blankRow()],
      workflowStatus: "draft",
      signedAt: null,
      submitting: false,
      loading: true,
    };
  },
  computed: {
    isSigned() {
      return this.workflowStatus === "signed";
    },
    preventiveApi() {
      return {
        pdfUrl: (id) => preventiveMeasureAPI.pdfUrl(id),
        sign: (id, payload) => preventiveMeasureAPI.sign(id, payload),
      };
    },
    dashboard() {
      let ejec = 0, proc = 0, noej = 0, sum = 0;
      const n = this.rows.length;
      this.rows.forEach((r) => {
        const a = Number(r.avance) || 0;
        sum += a;
        if (a >= 100) ejec++; else if (a > 0) proc++; else noej++;
      });
      return { total: n, ejecutadas: ejec, en_proceso: proc, no_ejecutadas: noej, eficacia: n ? Math.round(sum / n) : 0 };
    },
  },
  methods: {
    goBack() { this.$router.go(-1); },
    estado(avance) {
      const a = Number(avance) || 0;
      if (a >= 100) return { label: "Ejecutado", cls: "badge-success" };
      if (a > 0) return { label: "En Proceso", cls: "badge-warning" };
      return { label: "No Ejecutado", cls: "badge-danger" };
    },
    addRow() { if (!this.isSigned) this.rows.push(blankRow()); },
    removeRow(idx) {
      if (this.isSigned) return;
      this.rows.splice(idx, 1);
      if (!this.rows.length) this.rows.push(blankRow());
    },
    fileName(url) { return String(url).split("/").pop(); },
    load() {
      if (!this.matrixId) { this.loading = false; return; }
      preventiveMeasureAPI.get(this.matrixId)
        .then((r) => {
          if (!r) { this.loading = false; return; }
          this.form.version = r.version || "1.0";
          this.form.fecha = r.fecha ? String(r.fecha).substring(0, 10) : this.form.fecha;
          this.form.observacion = r.observacion || null;
          this.rows = (r.rows && r.rows.length)
            ? r.rows.map((x) => ({ ...blankRow(), ...x, fecha_limite: x.fecha_limite ? String(x.fecha_limite).substring(0, 10) : null }))
            : [blankRow()];
          this.workflowStatus = r.workflow_status || "draft";
          this.signedAt = r.signed_at || null;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    save() {
      if (this.isSigned) return;
      this.submitting = true;
      const payload = { companies_id: this.companyID, ...this.form, rows: this.rows };
      const req = this.matrixId ? preventiveMeasureAPI.update(this.matrixId, payload) : preventiveMeasureAPI.save(payload);
      req
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 45, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Matriz guardada.", icon: "success", timer: 1600, showConfirmButton: false });
          this.submitting = false;
          if (!this.matrixId && res && res.id) {
            this.matrixId = res.id;
            this.$router.replace({ path: `/forms/estandares/${this.companyID}/medidas-prevencion/${res.id}` });
          }
        })
        .catch((e) => { console.log(e); this.submitting = false; Swal.fire("Error", "No se pudo guardar la matriz", "error"); });
    },
    async onEvidenceFile(row, event) {
      if (this.isSigned) return;
      const file = event.target.files[0];
      if (!file) return;
      row._uploading = true;
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const path = `${base}/${this.nit}/4.2.1/evidencias/${this.matrixId || "nuevo"}/${Date.now()}_${file.name}`;
        const ok = await uploadDocument(path, file);
        if (!ok) throw new Error("upload");
        row.evidencia_file = `${process.env.VUE_APP_BUCKET}/${path}`;
        Swal.fire({ title: "Evidencia cargada", icon: "success", timer: 1200, showConfirmButton: false });
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "No se pudo cargar la evidencia", "error");
      } finally {
        row._uploading = false;
        if (event.target) event.target.value = null;
      }
    },
    removeEvidence(row) { if (!this.isSigned) row.evidencia_file = null; },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() {
    preventiveMeasureAPI.catalog().then((c) => { if (c) this.catalog = { ...this.catalog, ...c }; });
    this.load();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-9" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <CheckModal>
              <p class="text-justify">
                Registra las medidas de prevención y control para intervenir los peligros de la matriz de riesgos
                (4.1.2), aplicando la jerarquía de controles. Por cada medida indica el peligro asociado, la jerarquía,
                la fecha límite, el % de avance (la plataforma calcula el estado/semáforo) y adjunta la evidencia. Cada
                guardado es una versión y puede firmarse.
              </p>
            </CheckModal>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 Esta versión ya fue firmada; los datos quedan bloqueados. Usa "Nueva versión" en el listado para crear una revisión editable.
            </div>

            <form @submit.prevent="save">
              <div class="form-row">
                <b-form-group class="col-md-2 px-2" label="Versión">
                  <b-form-input type="text" v-model="form.version" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="Fecha">
                  <b-form-input type="date" v-model="form.fecha" :disabled="isSigned" required />
                </b-form-group>
                <b-form-group class="col-md-7 px-2" label="Observación">
                  <b-form-input type="text" v-model="form.observacion" :disabled="isSigned" />
                </b-form-group>
              </div>

              <div class="d-flex justify-content-between align-items-center mt-2">
                <h5 class="mb-0">Medidas</h5>
                <span class="small">
                  <span class="badge badge-success">Ejecutadas: {{ dashboard.ejecutadas }}</span>
                  <span class="badge badge-warning">En proceso: {{ dashboard.en_proceso }}</span>
                  <span class="badge badge-danger">No ejecutadas: {{ dashboard.no_ejecutadas }}</span>
                  <span class="badge badge-info">Eficacia: {{ dashboard.eficacia }}%</span>
                </span>
              </div>

              <div v-for="(row, idx) in rows" :key="idx" class="border rounded p-2 mb-3">
                <div class="d-flex justify-content-between">
                  <strong class="small text-primary">Medida #{{ idx + 1 }}</strong>
                  <button type="button" class="btn btn-outline-danger btn-sm py-0" :disabled="isSigned" @click="removeRow(idx)">
                    <i class="mdi mdi-trash-can"></i>
                  </button>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-3 px-2" label="Peligro asociado">
                    <b-form-select v-model="row.peligro" :disabled="isSigned" size="sm">
                      <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                      <b-form-select-option v-for="p in catalog.peligros" :key="p" :value="p">{{ p }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Medida de prevención y control">
                    <b-form-input v-model="row.medida" :disabled="isSigned" size="sm" />
                  </b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Jerarquía del control">
                    <b-form-select v-model="row.jerarquia" :disabled="isSigned" size="sm">
                      <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                      <b-form-select-option v-for="j in catalog.jerarquia" :key="j" :value="j">{{ j }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="form-row align-items-end bg-light rounded py-1">
                  <b-form-group class="col-md-3 px-2" label="Fecha límite">
                    <b-form-input type="date" v-model="row.fecha_limite" :disabled="isSigned" size="sm" />
                  </b-form-group>
                  <b-form-group class="col-md-3 px-2" label="% Avance">
                    <b-form-input type="number" min="0" max="100" v-model.number="row.avance" :disabled="isSigned" size="sm" />
                  </b-form-group>
                  <div class="col-md-3 px-2 pb-2">
                    <span class="badge" :class="estado(row.avance).cls">{{ estado(row.avance).label }}</span>
                  </div>
                </div>
                <div class="form-row align-items-end">
                  <b-form-group class="col-md-6 px-2" label="Observaciones / soporte">
                    <b-form-input v-model="row.observaciones" :disabled="isSigned" size="sm" />
                  </b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Adjuntar evidencia">
                    <b-form-file :disabled="isSigned || row._uploading" browse-text="Buscar"
                      :placeholder="row._uploading ? 'Subiendo...' : 'Selecciona un archivo...'" @change="onEvidenceFile(row, $event)" size="sm" />
                  </b-form-group>
                  <div class="col-md-2 px-2 pb-2 small">
                    <span v-if="row.evidencia_file">
                      <a :href="row.evidencia_file" target="_blank"><i class="mdi mdi-paperclip"></i> {{ fileName(row.evidencia_file) }}</a>
                      <button v-if="!isSigned" type="button" class="btn btn-outline-danger btn-sm py-0 ml-1" @click="removeEvidence(row)"><i class="mdi mdi-close"></i></button>
                    </span>
                    <span v-else class="text-muted">Sin archivo</span>
                  </div>
                </div>
              </div>

              <button type="button" class="btn btn-outline-primary btn-sm mb-3" :disabled="isSigned" @click="addRow">
                <i class="mdi mdi-plus"></i> Agregar medida
              </button>

              <div class="text-right">
                <button type="submit" :disabled="isSigned || submitting" class="btn btn-primary mx-1">Guardar</button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-3" v-if="!loading && matrixId">
        <h6 class="text-muted small mb-1">Matriz de Medidas de Prevención y Control</h6>
        <DocumentActions
          :document-id="Number(matrixId)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="preventiveApi"
          document-title="Matriz de Medidas de Prevención y Control"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
    </div>
  </Layout>
</template>
